export const pushCookieConsentEventToDataLayer = (eventName: string) =>
  window.dataLayer.push({ event: 'Cookie Consent - Events', label: eventName });
